<ion-header>
  <ion-toolbar>
    <ion-title>NKP-eredmények beillesztése</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="megse()"><ion-icon slot="icon-only" name="close"></ion-icon></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-note color="medium" class="nkp-blokk">
    Az NKP-ban nyisd meg a feladat eredményeit, jelöld ki a <b>teljes listát</b> (a névtől a
    „Megjegyzések” oszlopig), másold ki, és illeszd be ide. Az időkedvezményesek listáját is
    ugyanide, egymás alá másolhatod. A rendszer név alapján párosít a kiválasztott osztály/csoport
    névsorához, és a <b>kerekített százalékot</b> veszi.
  </ion-note>

  <ion-textarea fill="outline" [autoGrow]="true" rows="6" [(ngModel)]="szoveg"
                placeholder="Felhasználó	Legjobb eredmény&#10;Kiss Anna anna@gmail.com	48.48 pont (48.5%)	1 megoldás	Megjegyzések"
                (ionInput)="feldolgozva = false"></ion-textarea>

  <div class="nkp-beallitasok">
    <ion-segment [(ngModel)]="mod" [disabled]="modZarolt">
      <ion-segment-button value="2"><ion-label>Százalék</ion-label></ion-segment-button>
      <ion-segment-button value="1"><ion-label>Érdemjegy ponthatárral</ion-label></ion-segment-button>
    </ion-segment>
    <ion-note color="medium" *ngIf="modZarolt">A tantárgy jegyei már egy formában vannak, ezért a mód nem változtatható.</ion-note>
    <div class="nkp-hatarok" *ngIf="mod === '1'">
      <span>Alsó határ (%):</span>
      <label>2-es <input type="number" min="0" max="100" [(ngModel)]="hatarok[0]" (ngModelChange)="hatarValt()"></label>
      <label>3-as <input type="number" min="0" max="100" [(ngModel)]="hatarok[1]" (ngModelChange)="hatarValt()"></label>
      <label>4-es <input type="number" min="0" max="100" [(ngModel)]="hatarok[2]" (ngModelChange)="hatarValt()"></label>
      <label>5-ös <input type="number" min="0" max="100" [(ngModel)]="hatarok[3]" (ngModelChange)="hatarValt()"></label>
    </div>
    <ion-checkbox [(ngModel)]="nemIrtaJelol" labelPlacement="end">
      „Nem kezdett hozzá” és „Még nem adta be” → <b>– nem írta meg</b> (később jegyre írható át)
    </ion-checkbox>
  </div>

  <ion-button (click)="feldolgoz()" [disabled]="!szoveg.trim()">Feldolgozás</ion-button>

  <ng-container *ngIf="feldolgozva">
    <div class="nkp-osszeg">
      <b>{{ sorok.length }}</b> eredmény a listában ·
      <b>{{ beirhato }}</b> beírható
      <span *ngIf="parositatlan" class="nkp-figy"> · {{ parositatlan }} nincs párosítva (válaszd ki lent)</span>
      <span *ngIf="duplak.size" class="nkp-figy"> · {{ duplak.size }} tanulóhoz két sor tartozik (az egyiket állítsd „kihagy”-ra)</span>
      <span *ngIf="hibak.length" class="nkp-figy"> · {{ hibak.length }} sor nem értelmezhető</span>
    </div>

    <table class="nkp-tabla">
      <thead><tr><th>NKP-név</th><th>Eredmény</th><th>Tanuló a névsorban</th><th>Beírás</th></tr></thead>
      <tbody>
        <tr *ngFor="let s of sorok" [class.nkp-hiany]="!s.oktazon" [class.nkp-dupla]="s.oktazon && duplak.has(s.oktazon)">
          <td>{{ s.nev }}<div class="nkp-kicsi" *ngIf="s.email">{{ s.email }}</div></td>
          <td>{{ eredmenySzoveg(s) }}</td>
          <td>
            <select [(ngModel)]="s.oktazon">
              <option value="">— kihagy —</option>
              <option *ngFor="let t of nevsor" [value]="t.oktazon">{{ t.nev }}</option>
            </select>
            <div class="nkp-kicsi" *ngIf="s.mod === 'reszleges'">részleges névegyezés – ellenőrizd</div>
            <div class="nkp-kicsi nkp-figy" *ngIf="!s.oktazon && s.jeloltek > 1">több hasonló nevű tanuló</div>
          </td>
          <td class="nkp-ertek">{{ s.oktazon && !duplak.has(s.oktazon) ? (ertek(s) || '—') : '—' }}<span *ngIf="mod === '2' && s.allapot === 'eredmeny' && s.oktazon">%</span></td>
        </tr>
      </tbody>
    </table>

    <div *ngIf="hibak.length" class="nkp-blokk">
      <b>Nem értelmezhető sorok</b> (kimaradnak):
      <div class="nkp-kicsi" *ngFor="let h of hibak">{{ h.sor }}. sor: {{ h.szoveg }}</div>
    </div>
    <div *ngIf="kimaradtTanulok.length" class="nkp-blokk">
      <b>A névsorból a listában nem szereplők ({{ kimaradtTanulok.length }}):</b>
      {{ kimaradtNevek }} – nekik nem írunk semmit.
    </div>
  </ng-container>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <div class="nkp-gombok">
      <ion-button color="primary" (click)="mehet()" [disabled]="!feldolgozva || !beirhato">
        Beírás a névsorba ({{ beirhato }})
      </ion-button>
      <ion-button fill="clear" color="medium" (click)="megse()">Mégse</ion-button>
    </div>
    <ion-note color="medium" class="nkp-lab">Ezután a névsorban ellenőrizd, és a <b>Mentés</b> gombbal rögzítsd.</ion-note>
  </ion-toolbar>
</ion-footer>
